import React from "react"

export default ({ name } = {}) => ({
  name,
  type: "display",
  component: () => {
    return <div>Display settings</div>
  },
  css: value => {
    return `
      .built-with {
        display: ${value === "true" ? "block" : "none"};
      }
    `
  }
})
